import { render, staticRenderFns } from "./StatusBtn.vue?vue&type=template&id=28cd8ca7&"
import script from "./StatusBtn.vue?vue&type=script&lang=js&"
export * from "./StatusBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports